import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class CorporateCategoryInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'CorporateCategory',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.billingInformation.category
  }
}
